import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HomeComponentsService } from 'src/app/services/home-components.service';
import { DashboardFastAccessNotificationsResponse } from '../models/dashboard-fast-access-notifications.model';
import {
  EMPTY_SIDEBAR_MENU_BADGE_COUNTS,
  SidebarMenuBadgeCounts,
} from '../models/sidebar-menu-badge-counts.model';

/**
 * Contadores de badge del menú v2.
 * `pqrs` (badge "Tickets") refleja los tickets NUEVOS/sin triar del backend
 * nuevo (v2 tickets); el resto sigue viniendo del fast-access legacy.
 */
@Injectable({
  providedIn: 'root',
})
export class SidebarMenuBadgesService {
  private readonly _counts$ = new BehaviorSubject<SidebarMenuBadgeCounts>(EMPTY_SIDEBAR_MENU_BADGE_COUNTS);

  readonly counts$: Observable<SidebarMenuBadgeCounts> = this._counts$.asObservable();

  constructor(private homeComponentsService: HomeComponentsService) {}

  refresh(): void {
    forkJoin({
      fastAccess: this.homeComponentsService
        .getNotificationsFastAccess()
        .pipe(catchError(() => of(null))),
      ticketsNew: this.homeComponentsService
        .getTicketsNewCount()
        .pipe(catchError(() => of(0))),
    }).subscribe({
      next: ({ fastAccess, ticketsNew }) => {
        this._counts$.next(
          this.mapToBadgeCounts(fastAccess as DashboardFastAccessNotificationsResponse | null, ticketsNew),
        );
      },
      error: () => this._counts$.next(EMPTY_SIDEBAR_MENU_BADGE_COUNTS),
    });
  }

  private mapToBadgeCounts(
    resp: DashboardFastAccessNotificationsResponse | null,
    ticketsNew: number,
  ): SidebarMenuBadgeCounts {
    return {
      preRegistrations: resp?.data?.tmpUserNotifications?.created ?? 0,
      chat: resp?.data?.chatNotifications?.notRead ?? 0,
      reservations: resp?.data?.reservationNotifications?.waitingApprove ?? 0,
      pqrs: ticketsNew,
    };
  }
}
